import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import AppRoutes from "./routes/AppRoutes";
import "./styles/global.css";

/**
 * Main App Component
 * Wrapped with HelmetProvider for SEO meta tag management
 * Uses centralized routing structure with lazy loading
 */
function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppRoutes />
      </Router>
    </HelmetProvider>
  );
}

export default App;
